<template>
  <div :class="{ collapsed: !expanded }" class="Sidebar">
    <router-link :to="{ path: baseRoute }" class="logo">
      <img src="./assets/logo.svg" />
    </router-link>
    <ul class="general">
      <li>
        <router-link
          v-slot="{ navigate }"
          :to="{ path: `${baseRoute}/dashboard` }"
        >
          <a
            :class="{ 'router-link-active': isActiveSection('dashboard') }"
            @click="navigate"
          >
            <div class="bg" />
            <img
              style="width: 24px; left: 38px"
              class="active_img"
              src="./assets/dashboard_active.svg"
            />
            <img
              style="width: 24px; left: 38px"
              class="inactive_img"
              src="./assets/dashboard.svg"
            />
            <span>{{ t('shared.navigation.start') }}</span>
          </a>
        </router-link>
      </li>

      <li>
        <router-link
          v-slot="{ navigate }"
          :to="{ path: `${baseRoute}/data-mappings` }"
        >
          <a
            :class="{ 'router-link-active': isActiveSection('data-mappings') }"
            @click="navigate"
          >
            <div class="bg" />
            <img
              style="width: 29px; left: 36px"
              class="active_img"
              src="./assets/data_mapping_active.svg"
            />
            <img
              style="width: 29px; left: 36px"
              class="inactive_img"
              src="./assets/data_mapping.svg"
            />
            <span>{{ t('shared.navigation.data_mappings') }}</span>
          </a>
        </router-link>
      </li>

      <li>
        <router-link
          v-slot="{ navigate }"
          :to="{ path: `${baseRoute}/documents` }"
        >
          <a
            :class="{ 'router-link-active': isActiveSection('documents') }"
            @click="navigate"
          >
            <div class="bg" />
            <img
              style="width: 23px; left: 39px"
              class="active_img"
              src="./assets/document_active.svg"
            />
            <img
              style="width: 23px; left: 39px"
              class="inactive_img"
              src="./assets/document.svg"
            />
            <span>{{ t('shared.navigation.documents') }}</span>
          </a>
        </router-link>
      </li>

      <li>
        <router-link
          v-slot="{ navigate }"
          :to="{ path: `${baseRoute}/review-processes` }"
        >
          <a
            :class="{
              'router-link-active': isActiveSection('review-processes'),
            }"
            @click="navigate"
          >
            <div class="bg" />
            <img
              style="width: 25px; left: 38px"
              class="active_img"
              src="./assets/reviewprocess_active.svg"
            />
            <img
              style="width: 25px; left: 38px"
              class="inactive_img"
              src="./assets/reviewprocess.svg"
            />
            <span>{{ t('shared.navigation.review_processes') }}</span>
          </a>
        </router-link>
      </li>

      <li>
        <router-link
          v-slot="{ navigate }"
          :to="{ path: `${baseRoute}/requests` }"
        >
          <a
            :class="{ 'router-link-active': isActiveSection('requests') }"
            @click="navigate"
          >
            <div class="bg" />
            <img
              style="width: 25px; left: 38px"
              class="active_img"
              src="./assets/request_active.svg"
            />
            <img
              style="width: 25px; left: 38px"
              class="inactive_img"
              src="./assets/request.svg"
            />
            <span>{{ t('shared.navigation.requests') }}</span>
          </a>
        </router-link>
      </li>

      <li>
        <router-link
          v-slot="{ navigate }"
          :to="{ path: `${baseRoute}/incidents` }"
        >
          <a
            :class="{ 'router-link-active': isActiveSection('incidents') }"
            @click="navigate"
          >
            <div class="bg" />
            <img
              style="width: 24px; left: 38px"
              class="active_img"
              src="./assets/incident_active.svg"
            />
            <img
              style="width: 24px; left: 38px"
              class="inactive_img"
              src="./assets/incident.svg"
            />
            <span>{{ t('shared.navigation.incidents') }}</span>
          </a>
        </router-link>
      </li>

      <li>
        <router-link
          v-slot="{ navigate }"
          :to="{ path: `${baseRoute}/systems` }"
        >
          <a
            :class="{ 'router-link-active': isActiveSection('systems') }"
            @click="navigate"
          >
            <div class="bg" />
            <img
              style="width: 27px; left: 38px"
              class="active_img"
              src="./assets/system_active.svg"
            />
            <img
              style="width: 27px; left: 38px"
              class="inactive_img"
              src="./assets/system.svg"
            />
            <span>{{ t('shared.navigation.systems') }}</span>
          </a>
        </router-link>
      </li>

      <li>
        <router-link
          v-slot="{ navigate }"
          :to="{ path: `${baseRoute}/data-processors` }"
        >
          <a
            :class="{
              'router-link-active': isActiveSection('data-processors'),
            }"
            @click="navigate"
          >
            <div class="bg" />
            <img
              style="width: 25px; left: 38px"
              class="active_img"
              src="./assets/data_processor_active.svg"
            />
            <img
              style="width: 25px; left: 38px"
              class="inactive_img"
              src="./assets/data_processor.svg"
            />
            <span>{{ t('shared.navigation.data_processors') }}</span>
          </a>
        </router-link>
      </li>
    </ul>
    <ul class="log-out">
      <LocaleSelector :sidebar-expanded="expanded" />
      <li>
        <a href="https://compliancelog.dk/#/kontakt" target="_blank">
          <div class="bg" />
          <img
            style="width: 25px; left: 38px"
            class="inactive_img"
            src="./assets/request.svg"
          />
          <span>{{ t('shared.navigation.help') }}</span>
        </a>
      </li>
      <li v-if="!expanded">
        <a href="#" @click="expandSidebar()">
          <div class="bg" />
          <img
            style="
              width: 23px;
              left: 37px;
              top: 13px;
              transform: rotate(180deg);
            "
            class="inactive_img"
            src="./assets/arrow.svg"
          />
          <span>{{ t('shared.navigation.log_out') }}</span>
        </a>
      </li>
      <li v-if="expanded">
        <a href="#" @click="logOut()">
          <div class="bg" />
          <img
            style="width: 23px; left: 38px"
            class="inactive_img"
            src="./assets/log_out.svg"
          />
          <span>{{ t('shared.navigation.log_out') }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LocaleSelector from '@/components/LocaleSelector'

export default {
  name: 'Sidebar',
  components: { LocaleSelector },
  computed: {
    ...mapState({
      expanded: state => state.sidebar.expanded,
      baseRoute: state => `/organizations/${state.route.params.organizationId}`,
    }),
    currentPath() {
      return this.$route.path
    },
  },
  methods: {
    ...mapActions(['logOut', 'expandSidebar']),
    isActiveSection(section) {
      // Check if current path contains the section
      return this.currentPath.includes(`/${section}`)
    },
  },
}
</script>

<style lang="scss">
@import 'style.scss';
</style>
